<template>
  <div class="candidature-steps">
    <div v-if="this.level > 0" class="candidature-steps-group">
      <div class="candidature-steps-group-circle candidature-steps-group-circle--active" @click="clickPageOne">1</div>
      <div class="candidature-steps-group-text candidature-steps-group-text--active">Informations personnelles</div>
    </div>
    <div v-else class="candidature-steps-group">
      <div class="candidature-steps-group-circle">1</div>
      <div class="candidature-steps-group-text">Informations personnelles</div>
    </div>

    <div v-if="this.level > 1" class="candidature-steps-border candidature-steps-border--active"/>
    <div v-else class="candidature-steps-border"/>

    <div v-if="this.level > 1" class="candidature-steps-group">
      <div class="candidature-steps-group-circle candidature-steps-group-circle--active" @click="clickPageTwo">2</div>
      <div class="candidature-steps-group-text candidature-steps-group-text--active">Parcours professionnel</div>
    </div>
    <div v-else class="candidature-steps-group">
      <div class="candidature-steps-group-circle">2</div>
      <div class="candidature-steps-group-text">Parcours professionnel</div>
    </div>

    <div v-if="this.level > 2" class="candidature-steps-border candidature-steps-border--active"/>
    <div v-else class="candidature-steps-border"/>

    <div v-if="this.level > 2" class="candidature-steps-group">
      <div class="candidature-steps-group-circle candidature-steps-group-circle--active">3</div>
      <div class="candidature-steps-group-text candidature-steps-group-text--active">Enregistrement du dossier</div>
    </div>
    <div v-else class="candidature-steps-group">
      <div class="candidature-steps-group-circle">3</div>
      <div class="candidature-steps-group-text">Enregistrement du dossier</div>
    </div>

  </div>
</template>

<script>
export default {
  name: "CandidatureSteps",
  props: {
    level: Number,
  },
  methods: {
    clickPageOne: function () {
      if (this.level > 1) {
        this.$router.push({name: 'ma-candidature-1'})
      }
    },
    clickPageTwo: function () {
      if (this.level > 2) {
        this.$router.push({name: 'ma-candidature-2'})
      }
    }
  },
};
</script>